// extracted by mini-css-extract-plugin
module.exports = {"errorText":"Processors_errorText__4y2b9","pendingMessage":"Processors_pendingMessage__15ydL","container":"Processors_container__3OUKz"};